import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export default function CheckboxAnswer({ question, responseHandler, validateField, disabled, error }) {
    const q = question;
    const id = question.questionID;

    const [checked, setChecked] = React.useState(q.response.responseText === '1');

    function handleChange(event) {
        const ch = event.target.checked;
        setChecked(ch);
        responseHandler(id, ch ? '1' : null, event);
        validateField();
    }

    return (
        <FormControl disabled={disabled} error={error}>
            <FormGroup>
                <FormControlLabel
                    className="questionnaire-body"
                    control={<Checkbox checked={checked} onChange={handleChange} name={`a${id}`} color="primary" />}
                    label={q.question}
                />
            </FormGroup>
        </FormControl>
    );
}
